import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useToast,
} from "@chakra-ui/react";
import {  useState } from "react";
import BookingService from "../../services/Booking"
export const InstantExpertModal = ({ isOpen, onClose,id}: any) => {
  const data = [
    {
      id: "65550109ae3116b32f4c802d",
      name: "	Siddharth Sharma",
    },
    {
      id: "653f8be92dd23c6fe040080b",
      name: "Kazi Nafisa Rahman",
    },
    {
      id: "653f98992dd23c6fe0400823",
      name: "Dowlath Nisha",
    },
    {
      id: "6527cdc88a7d888f55b85685",
      name: "Anuveet Kaur",
    },
    {
      id: "64ca1ee406a45f16c6185806",
      name: "Anuradha Kunte",
    },
    {
      id: "65463599594c9037204ebcb4",
      name: "Supritha",
    },
    {
      id: "64ca270306a45f16c6185813",
      name: "Divya Khanna",
    },
    {
      id: "6495495ac5ab90a9c769777c",
      name: "Khushbu Ahmad",
    },
    {
      id: "649442ffc5ab90a9c7697751",
      name: "Tamanna Rajpal",
    },
    {
      id: "651ff124dafb1176a73b893b",
      name: "Ayush Singh",
    },
  ];
  const [users, setUsers] = useState(data);
  const [selectedUser, setSelectedUser] = useState("");
  const toast = useToast();
  const handleSubmit = () => {
    BookingService.updateInstantExpert(id,"true",selectedUser).then((res)=>{
      const success = res.data.success;
     const  message = res.data.message;
      if(success){

        toast({
          position: "top",
          // title: "Login Successfull.",
          description:message,
          status: "success",
          duration: 500,
          isClosable: true,
        });
      }else{

        toast({
          position: "top",
          // title: "Login Failed.",
          description: message,
          status: "error",
          duration: 1000,
          isClosable: true,
        });
      }
    }).catch((e)=>{
      toast({
        position: "top",
        // title: "Login Failed.",
        description: e.message,
        status: "error",
        duration: 1000,
        isClosable: true,
      });
    })
    // if (selectedUsers.length > 0) {
    //   const tokens = selectedUsers.map((el: any) => el.value);
    //   NotificationService.sendNotification(id, "specific", tokens);
    // }
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Instant Experts</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
        <Select
        width="100%" 
        onChange={(e) => setSelectedUser(e.target.value)}
      >
        {users.map((el: any) => (
          <option key={el.id} value={el.id}>
            {el.name}
          </option>
        ))}
      </Select>
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={handleSubmit}
          >
            Send
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
